import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { useState, useEffect } from 'react';
const App = () => {
  const [quote, setQuote] = useState("");
  const getQuote = () => {
    fetch('https://type.fit/api/quotes')
      .then(res => res.json())
      .then(data => { let random_number = Math.floor(Math.random() * data.length); setQuote(data[random_number]); })
  };
  useEffect(getQuote, []);

  return (<>
    <div className="card" id="quote-box">

      <div className="card-header text-center fw-bold">QUOTE</div>
      <div className="card-body">
        <blockquote className="blockquote mb-0" id="text">
          <p>{quote.text}</p>
          <footer className="blockquote-footer" id="author">
            Written by  ~<cite title="Source Title">{quote.author}</cite>
          </footer>
        </blockquote>
        <div className="Links">

          <a href={`https://twitter.com/intent/tweet?text=${quote.text + "  ~" + quote.author}`} target='_blank' id='tweet-quote'>
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-twitter" viewBox="0 0 16 16">
  <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"/>
          </svg>
            </a>
          <button id='new-quote' type="button" onClick={getQuote} class="btn btn-outline-success">Next Quote</button>
        </div>
      </div>
    </div>
  </>);
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

reportWebVitals();
{ }